<template>
  <div>
    <page-title value="ユーザー設定"></page-title>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";

export default defineComponent({
  name: "MeSetting",

  components: {
    PageTitle,
  },
});
</script>
